import type { ContentHref } from '@generalTypes/apiTypes';
import { contentApi } from '@store/api/apiConfig';

export const fetchIsIncludedInProTheme = async (href: ContentHref) => {
  const results = await contentApi.getList('/content', {
    leaf: href,
    tagsIn: 'WEBPAGE2',
    limit: 1,
    expand: 'NONE',
  });

  return results.length === 1;
};
